var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personalised-offers page"},[_c('magic-personalised-offers-modal',{attrs:{"slug":_vm.$route.params.slug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }